import React, {useState} from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import {BlackMask} from "../../../../components/mask";
import BottomToTop from "../../../../components/transitions/bottom-to-top";
import Checkout from "../checkout";
import {Iconfont} from "../../../../components/icon/iconfont";
export default  props => {
    useStyles(classes);
    const { showModal, onClose,selectedProduct,selectedVariant } = props
    const handleClose=()=>{
        onClose()
    }
    return  <React.Fragment>
        <BottomToTop in={showModal} className={classes.QuickCheckoutModal}>
        <div>
            <div className={classes.SecureData}>
                <Iconfont>&#xE7BF;</Iconfont><span className={classes.SecureDataMsg}>Your data is protected.</span>
                <Iconfont className={classes.Close} onClick={handleClose}>&#xe7c9;</Iconfont>
            </div>

            <Checkout quickBuy={true} hidenPlaceOrder={!showModal} selectedProduct={selectedProduct} selectedVariant={selectedVariant}/>
        </div>
        </BottomToTop>
        {
            showModal && <BlackMask onClick={handleClose} style={{"zIndex":8}}/>
        }
    </React.Fragment>
}